module.exports = __webpack_public_path__ + "media/assets/logo_flat-3719573f8f3cce5eb2e06e8452b9dc07.png";